var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgUsersLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30.3,
    viewBox: "0 0 24 30.3"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-users-link_svg__cls-1,.kpmg-users-link_svg__cls-3{stroke-linecap:round}.kpmg-users-link_svg__cls-1{fill:#fff;stroke-linejoin:round;stroke-width:.5px;stroke:#fff}.kpmg-users-link_svg__cls-3{fill:none;stroke-width:1.6px;stroke:#30acec}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-users-link_svg__ICN_Utilizatori_Active",
    transform: "translate(-119 -151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-users-link_svg__Group_1244",
    "data-name": "Group 1244",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-users-link_svg__Group_1243",
    "data-name": "Group 1243",
    transform: "translate(276.359 337.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-users-link_svg__Group_1242",
    "data-name": "Group 1242",
    transform: "translate(-153 -182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-users-link_svg__Path_891",
    d: "M-68.326-171.192h.121a3.478 3.478 0 002.658-1.15c1.451-1.636 1.21-4.44 1.183-4.708a3.846 3.846 0 00-1.828-3.419 4.191 4.191 0 00-2.029-.531h-.064a4.2 4.2 0 00-2.028.516 3.848 3.848 0 00-1.851 3.434c-.026.268-.268 3.072 1.184 4.708a3.464 3.464 0 002.654 1.15zm-2.831-5.763v-.03c.124-2.7 2.043-2.993 2.865-2.993h.045c1.018.023 2.748.437 2.865 2.993a.072.072 0 000 .03c0 .026.268 2.59-.931 3.939a2.47 2.47 0 01-1.941.807h-.038a2.463 2.463 0 01-1.937-.807c-1.195-1.342-.938-3.916-.935-3.939zm0 0",
    className: "kpmg-users-link_svg__cls-1",
    "data-name": "Path 891",
    transform: "translate(76.002 181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-users-link_svg__Path_892",
    d: "M-137.519 31.084v-.105c-.022-.746-.072-2.492-1.707-3.049l-.038-.011a10.879 10.879 0 01-3.129-1.425.508.508 0 00-.709.124.508.508 0 00.124.709 11.751 11.751 0 003.442 1.572c.878.313.976 1.251 1 2.111a.74.74 0 000 .094 6.859 6.859 0 01-.079 1.165c-.472.83-3.208 2.458-6.849 2.458-3.626 0-6.369-1.5-6.445-2.462a6.474 6.474 0 01-.079-1.165v-.094c.027-.859.124-1.8 1-2.111a11.841 11.841 0 003.441-1.572.508.508 0 00.124-.709.508.508 0 00-.709-.124 10.757 10.757 0 01-3.129 1.425l-.038.011c-1.636.562-1.685 2.307-1.707 3.049a.774.774 0 010 .094v.011a5.778 5.778 0 00.192 1.707.483.483 0 00.2.237 10.4 10.4 0 007.154 2.715 12.115 12.115 0 007.561-2.715c.087-.056.339-.139.377-.237a4.982 4.982 0 000-1.7zm0 0",
    className: "kpmg-users-link_svg__cls-1",
    "data-name": "Path 892",
    transform: "translate(153 -15.969)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-users-link_svg__Ellipse_185",
    "data-name": "Ellipse 185",
    transform: "translate(119 152)",
    strokeWidth: 1.6,
    fill: "none",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-users-link_svg__Line_165",
    d: "M0 0h13",
    className: "kpmg-users-link_svg__cls-3",
    "data-name": "Line 165",
    transform: "translate(124.5 177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-users-link_svg__Line_166",
    d: "M0 0h7",
    className: "kpmg-users-link_svg__cls-3",
    "data-name": "Line 166",
    transform: "translate(127.5 180.5)"
  }))));
}

export default SvgKpmgUsersLink;